import { Fragment } from 'react';
import { Col, Form, Row } from 'react-bootstrap';

import { ControlesLinha, ProcessoInput } from '../../components/RelatorioCivelComponents';

import type { RelatorioCivelStepProps } from './relatorio-civel-step-props';

export default function Step06Manifestacao(props: RelatorioCivelStepProps) {
  const {
    novoProcessoManifestacao,
    setNovoProcessoManifestacao,
    adicionarProcesso,
    quantidadeLinhas,
    setQuantidadeLinhas,
    adicionarMultiplasLinhas,
    isViewMode,
    formData,
    renderTabelaProcessos,
  } = props;

  return (
    <Fragment>
      {!isViewMode && (
        <Row className="mb-4">
          <Col md={12}>
            <Form.Group>
              <Form.Label className="fw-bold">N.º do Processo</Form.Label>
              <ProcessoInput
                value={novoProcessoManifestacao}
                onChange={setNovoProcessoManifestacao}
                onAdicionar={() =>
                  adicionarProcesso('manifestacao', novoProcessoManifestacao, setNovoProcessoManifestacao)
                }
              />
              <Form.Text className="text-muted">
                Pressione Enter ou clique em Adicionar para incluir o processo na lista
              </Form.Text>
            </Form.Group>
          </Col>
        </Row>
      )}

      {!isViewMode && (
        <ControlesLinha
          quantidade={quantidadeLinhas.manifestacao}
          onDecrementar={() =>
            setQuantidadeLinhas((prev) => ({ ...prev, manifestacao: Math.max(1, prev.manifestacao - 1) }))
          }
          onIncrementar={() =>
            setQuantidadeLinhas((prev) => ({ ...prev, manifestacao: Math.min(50, prev.manifestacao + 1) }))
          }
          onQuantidadeChange={(value: number) =>
            setQuantidadeLinhas((prev) => ({ ...prev, manifestacao: value }))
          }
          onAdicionar={() => adicionarMultiplasLinhas('manifestacao')}
          totalLabel="Total de Processos"
          totalCount={formData.manifestacao.processos.length}
        />
      )}

      {renderTabelaProcessos('manifestacao', formData.manifestacao.processos)}
    </Fragment>
  );
}

